module.exports = __webpack_public_path__ + "img/Slide15.37f50527.png";